import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { ClassPage, ClassSelectionProvider } from '@features/class/components/ClassPage'
import { classQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/classes/$classId')(
    {
        component: RouteComponent,
        loader: async ({ params, context }) => {
            context.queryClient.ensureQueryData(classQueryOptions({ mode: 'id', id: params.classId }))
            return null
        },
        staticData: {
            crumb: {
                dynamicLabel: (match)  => `Class ${match.params.classId}`
            }
        }
    },
)

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load class'>
            <Suspense fallback={<LoadingIndicator resource='class' />}>
                <ClassSelectionProvider>
                    <ClassPage />
                </ClassSelectionProvider>
            </Suspense>
        </QueryErrorBoundary>
    )
}
